var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":_vm.gridId}}),(!_vm.rows || !_vm.rows.length)?_c('p',{staticClass:"p-4 text-grey"},[_vm._v("No data.")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }